import type { IconProps } from "@/types/IconProps";

export function CheckSharp(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={color}
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path strokeLinecap="square" d="m5 12.75 5 5L20.25 7.5" />
    </svg>
  );
}
